<!--
 * @Author: 271720
 * @Date: 2021-08-20 11:08:34
 * @LastEditTime: 2023-04-18 12:12:49
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 消防控制第二次开发
 * @FilePath: \鲁南\src\modules\fire\view\fireControlNew.vue
-->
<template>
  <div
    class="fire-control-page"
    v-loading="loadingCanvas"
    element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧page -->
      <div class="fire-control-main">
        <control-list
          ref="controlList"
          :data="cacheFireDeviceList"
          v-loading="canvasLoading"
          element-loading-text="数据绘制中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @leftClickItem="handleClickItem"
          @closeDetail="closeDetail"
          @handleType="handlePageType"
          @rightVideoClick="rightVideoClick"
          @handleUpdate="handleUpdate"
          @handleConfig="handleConfig"
          @handleUpdatePlace="handleUpdatePlace"
          @handleChangeImg="handleChangeImg"
          @nextPage="loadMoreControl"
          @handleSearchList="handleSearchList"
          @updateDeviceInfo="updateDeviceInfo"
        ></control-list>
      </div>
      <!-- 资源展示 -->
      <div class="fire-control-top">
        <div class="ioc-alarm__type pl-disabled" v-if="!controlPageType">
          资源展示：
          <span
            @click="clickDeviceType(item)"
            v-for="(item, index) in deviceTypes"
            :title="(item.isActive ? '隐藏' : '展示') + item.typeName"
            :key="index"
            :class="[item.img, { active: item.isActive }]"
          >
          </span>
        </div>
        <div class="control__pageImg" v-else>
          <el-button @click="handleUpdate('', 2)" type="info">选择楼层</el-button>
          <div style="margin: 0 12px">楼层名称：{{ buildingInfo.name }}</div>
          <div style="display: flex; margin-left: 100px">
            <el-button type="info" v-if="!canvasList.length" @click="handleCloseType"
              >取消</el-button
            >
            <el-button v-if="canvasList.length" type="info" @click="cancelSite"
              >全部取消</el-button
            >
            <el-button v-if="canvasList.length" type="primary" @click="addSite"
              >全部保存</el-button
            >
          </div>
        </div>
      </div>
      <!-- 右侧图纸 -->
      <div class="section-mian_right">
        <div class="canvasMain">
          <div
            class="canvasMainT"
            :style="{
              width: vW + '%',
              height: vH + '%',
              marginTop: getMarginTop + 'px',
              marginLeft: getMarinLeft + 'px',
            }"
          >
            <img
              class="louceng-img"
              v-if="hasDrawing"
              :src="!drawingSrc ? '/images/theme/newDark/default-drawing1.jpg' : $utils.Bus.imgPath(drawingSrc)"
            />
            <!-- /images/theme/newDark/default-drawing1.jpg -->
            <!-- 图层1 -->
            <canvas
              id="mycanvas"
              :width="cW"
              :height="cH"
              @mousewheel="mouseScroll"
              @DOMMouseScroll="mouseScroll"
              @mousedown="handleDomMoveStart"
              @drop="drop"
              @dragover.prevent
            ></canvas>
          </div>
        </div>
        <div class="marTip">
          <div>【 放大比例 {{ vW }}% 】</div>
        </div>
        <div v-if="!hasDrawing" class="no-drawing" @drop="drop" @dragover.prevent>
          无楼层图纸,请选择楼层!
        </div>
      </div>
      <!-- 设备详情 -->
      <controlDetail
        ref="controldetail"
        @handleVideo="handleVideo"
        :controlDetailInfo="controlDetailInfo"
      ></controlDetail>
      <!-- 消防设备图标 -->
      <img
        ref="cameraImg"
        class="alarm-img"
        draggable
        style="visibility: hidden; display: contents"
        src="../../../../public/images/theme/newDark/map/camera.png"
        width="20"
        height="20"
        alt=""
      />
      <img
        ref="dqhzImg"
        class="alarm-img"
        draggable
        style="visibility: hidden; display: contents"
        src="../../../../src/common/assets/images/map/resource/dqhz.png"
        width="20"
        height="20"
        alt=""
      />
      <img
        ref="imgRed"
        class="alarm-img"
        draggable
        style="visibility: hidden; display: contents"
        src="../../../../public/images/theme/newDark/map/alarm_state/1_1.png"
        width="20"
        height="20"
        alt=""
      />
      <img
        ref="img"
        style="visibility: hidden; display: contents"
        src="../../../../public/images/theme/newDark/device.png"
        width="20"
        height="20"
        alt=""
      />
      <img
        ref="imgCheck"
        style="visibility: hidden; display: contents"
        src="../../../../public/images/theme/newDark/deviceCheck.png"
        width="20"
        height="20"
        alt=""
      />
      <!-- 运行数据dialog -->
      <el-dialog title="运行数据" :visible.sync="linkDialog" width="1020px">
        <ioc-table
          style="height: 400px"
          ref="crud"
          :data="workingData"
          :option="workingOptions"
          :page="workingPage"
          @size-change="personChangeSize"
          @search-reset="handleSearchReset"
          @search-change="handleSearchChange"
          @current-change="currentChange"
        >
        </ioc-table>
      </el-dialog>
      <!-- 告警信息dialog -->
      <el-dialog title="告警信息" :visible.sync="alarmDialog" width="1020px" v-dialogDrag>
        <ioc-table
          ref="crud"
          :data="alarmlistData"
          :option="alarmlistOptions"
          :page="workingPage"
          @size-change="personChangeSize"
          @current-change="currentChange"
        >
        </ioc-table>
      </el-dialog>
    </div>
    <!-- 图纸上面点位气泡 -->
    <deviceCanvasTip
      v-if="showDeviceTip"
      :data="currentPop"
      :controlPageType="controlPageType"
      @equipmentOperation="equipmentOperation"
      @showOperationData="showOperationData"
      @alarmInfoList="alarmInfoList"
      @tipClose="showDeviceTip = false"
      class="canvasTip"
      :style="{
        left: tipStyle.left + 'px',
        top: tipStyle.top + 'px',
      }"
    />
    <!-- 楼栋/楼层图纸 -->
    <deviceChange ref="deviceChange" @confirmChange="handleConfirmFloor" />
    <!-- 一键配置 -->
    <keyConfigDialog ref="keyConfig" :deviceId="keyDeviceId" />

    <fireImg class="fireImg" ref="fireImg" style="visibility: hidden" />

    <el-dialog
      :visible.sync="fireMdialog"
      width="80%"
      v-dialogDrag
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <fireMange></fireMange>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import { mapState } from "vuex";
import { Dic, Cache, Bus, Base, Dates } from "$utils";
import utils from "@src/common/utils";
import keyConfigDialog from "../components/keyConfigDialog";
import controlList from "../components/controlList";
import controlDetail from "../components/controlDetail";
import deviceCanvasTip from "../components/deviceCanvasTip";
import { workingOptions } from "../config/operation";
import { tableOption } from "../config/alarmDetail";
import deviceMap from "../../cameraList/components/deviceMap";
import fireImg from "@src/modules/cameraList/components/fireImg";
import fireMange from "../../realTimeAlarm/view/FireManage";
import deviceChange from "../components/deviceChange.vue";
export default {
  components: {
    controlList,
    controlDetail,
    deviceCanvasTip,
    fireImg,
    fireMange,
    deviceChange,
    keyConfigDialog,
  },
  data() {
    return {
      keyDeviceId: "",
      tipStyle: { left: 0, top: 0 },
      buildingInfo: {
        name: "",
        id: "",
        fileCode: "",
      },
      deviceTypes: [
        {
          type: 18,
          typeName: "摄像机",
          img: "camera",
          isActive: true,
          list: [],
        },
        {
          type: 27,
          typeName: "消防设备",
          img: "fireDevice",
          isActive: true,
          list: [],
        },
        {
          type: 32,
          typeName: "电气火灾",
          img: "electric",
          isActive: true,
          list: [],
        },
      ],
      canvasLoading: false,
      fireMdialog: false,
      alarmDialog: false,
      cacheAlarmList: [],
      page: {
        pageSize: 30,
        currentPage: 1,
        total: 0,
      },
      workingPage: {
        pageNum: 1,
        total: 10,
        alarmType: [],
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 消防设备列表查询参数
      queryParams: {
        parentThirdDeviceId: "",
        positionFlag: "",
        relationCameraType: "",
        subDeviceMark: "",
        deviceMarkList: ["27", "28", "29"], //35,36,37
        deviceName: "",
        thirdDeviceIdAndNameStr: "",
        systemId: 200000024,
      },
      showType: 1, // 1 表示原始列表显示 2, 查询条件显示列表
      alarmId: "",
      drawingSrc: "",
      alarmDetail: {},
      controlDetailInfo: {},
      // 详情页下两点报警table表格row点击获得的详情
      rowClickInfo: {},
      // a)	点击运行数据弹窗，显示部件运行的数据列表
      linkDialog: false,
      workingOptions: workingOptions(),
      alarmlistOptions: tableOption(),
      workingData: [],
      cW: 0,
      cH: 0,
      canvasList: [], //渲染列表
      canvasChangList: [], //静态态canvas
      hasDrawing: true,
      showDeviceTip: false,
      rowLoopText: "",
      rowAddressText: "",
      relationAlarmInfoList: [],
      // 点击单个告警时获取当前楼层的所有设备并去重告警设备的数组
      excludeAlarmDeviceArr: [],
      clickItem: {},
      deviceNameId: "",
      dialogType: "",
      currentPop: {},
      alarmLevelPng: "",
      buildingPerson: "", //详情页的楼栋管理员
      securityPersonnel: "", //详情页的楼栋安全员
      alternatePersonnel: "", //详情页的楼栋备用安全员
      deviceId: "",
      alarmlistData: [],
      //  设备
      fireDeviceList: [],
      cacheFireDeviceList: [],
      openVideoSet: false, //是否开视频配置
      controlPageType: false, //页面控制模式：true:配置，false:控制
      loadingCanvas: false,
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
    ...mapState({
      fireAlarmNewList: (state) => state.ioc.fireAlarmNewList,
    }),
  },
  mixins: [deviceMap],
  watch: {
    getMarinLeft() {
      this.matchTip();
    },
    getMarginTop() {
      this.matchTip();
    },
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
  },
  beforeDestroy() {
    window.onresize = null;
  },
  created() {},
  mounted() {
    this.clickPoints();
    this.getFireControlList(this.page, this.queryParams);
    this.getCanvasWH();
    let _this = this;
    window.onresize = function () {
      _this.watchScreen();
    };
  },
  methods: {
    handleConfig(data) {
      this.keyDeviceId = data.deviceId;
      this.$nextTick(() => {
        this.$refs.keyConfig.open();
      });
    },
    // 拖拽结束事件
    drop(e) {
      if (!this.controlPageType) {
        this.$message.warning("如果需要拖动数据，请开启当前页面配置开关");
        return;
      }
      if (!this.buildingInfo.id) {
        this.$message.warning("请选择楼层图纸后配置位置");
        return;
      }
      let device = JSON.parse(e.dataTransfer.getData("item"));
      let isHave = this.canvasList.some((el, index) => {
        return el.deviceId == device.deviceId;
      });
      if (isHave) {
        this.$message.warning("该设备已经处于待确定状态，请勿重复拖拽");
        return;
      }
      let offsetX = e.offsetX;
      let offsetY = e.offsetY;
      this.canvasList.push({
        name: device.deviceName || device.parentDeviceName,
        thirdCameraId: device.thirdDeviceId,
        deviceId: device.deviceId,
        width: this.cW, //原始大小
        height: this.cH, //原始大小
        abscissa: offsetX,
        ordinate: offsetY,
        img: "yellow",
        x: offsetX,
        y: offsetY,
        subDeviceMark: device.subDeviceMark,
        deviceMark: device.deviceMark,
      });
      this.clearCanvas();
      this.getCanvasWH();
    },
    // 取消点位配置
    cancelSite() {
      this.clearCanvas();
      this.canvasList = [];
    },
    //保存点位配置
    addSite() {
      this.loadingCanvas = true;
      let params = {
        buildingCode: this.buildingInfo.id,
        singleFlag: true,
        deviceBuildingList: this.canvasList.map((item) => {
          return {
            abscissa: item.abscissa,
            buildingCode: this.buildingInfo.id,
            deviceId: item.deviceId,
            height: item.height,
            ordinate: item.ordinate,
            width: item.width,
          };
        }),
      };
      this.$fetch(api.device.updateDeviceBuilding, params).then((response) => {
        if (response.success) {
          this.loadingCanvas = false;
          this.$message.success("位置修改成功");
          this.cacheFireDeviceList = [];
          this.canvasList = [];
          this.getFireControlList(this.page, this.queryParams);
        } else {
          this.$message.error(response.msgContent || "位置修改失败");
        }
      });
    },
    // 打开楼栋/楼层
    handleUpdate(item, type) {
      this.$refs.deviceChange.open(item, type);
    },
    // 楼栋/楼从确定回调,    // 位置更改回调,type:如果type存在则是图纸和楼层信息
    handleConfirmFloor(item, area, type) {
      if (type) {
        this.handleChangeImg({
          ...item,
          fileCode: area,
        });
      } else {
        this.handleUpdatePlace(item, area, this.$refs.controlList.updatedDeviceInfo);
      }
    },
    handleCloseType() {
      this.$refs.controlList.$refs.controlTop.handleTypeChange(false);
      this.$refs.controlList.$refs.controlTop.controlType = false;
    },
    // 如果type为true：进入配置页面，false：进入控制页面
    handlePageType(type) {
      this.controlPageType = type;
      if (type) {
        // 配置页面关闭所有弹窗等提示信息和点位信息
        this.canvasList = [];
        this.hasDrawing = false;
        this.showDeviceTip = false;
        this.$refs.controlList.visibleRightId = "";
        this.closeDetail();
        this.clearCanvas();
      } else {
        // 重新请求left数据
        this.buildingInfo = {};
        this.hasDrawing = true;
        this.cacheFireDeviceList = [];
        this.getFireControlList(this.page, this.queryParams);
      }
    },
    // 视频配置回调
    handleVideo() {
      this.$refs.controldetail.handleClose();
      this.cacheFireDeviceList = [];
      this.getFireControlList(this.page, this.queryParams);
    },
    closeDetail() {
      this.$refs.controldetail.handleClose();
    },
    closeVideo() {
      this.$refs.controldetail.handleVideoClose();
    },
    updateDeviceInfo() {
      this.cacheFireDeviceList = [];
      this.getFireControlList(this.page, this.queryParams);
    },
    // 修改位置
    handleUpdatePlace(item, area, device) {
      let params = {
        buildingCode: area.id,
        singleFlag: true,
        deviceBuildingList: [
          {
            abscissa: item[0].abscissa,
            buildingCode: area.id,
            deviceId: device.deviceId,
            height: item[0].height,
            ordinate: item[0].ordinate,
            width: item[0].width,
          },
        ],
      };
      this.$fetch(api.device.updateDeviceBuilding, params).then((response) => {
        if (response.success) {
          this.$message.success("位置修改成功");
          this.$refs.controlList.closeDevicePlace();
          this.$refs.controldetail.handleClose();
          this.cacheFireDeviceList = [];
          this.getFireControlList(this.page, this.queryParams);
        } else {
          this.$message.error(response.msgContent || "位置修改失败");
        }
      });
    },
    handleChangeImg(val) {
      this.hasDrawing = true;
      this.buildingInfo = val;
      this.drawingSrc = val.fileCode;
    },
    // 资源显示和隐藏
    clickDeviceType(item) {
      item.isActive = !item.isActive;
      let list = [];
      console.log(this.deviceTypes);
      this.deviceTypes.forEach((el) => {
        if (el.isActive) {
          list = list.concat(el.list);
        }
      });
      this.canvasList = list;
      this.clearCanvas();
      this.getCanvasWH();
    },
    // 开始视频配置
    rightVideoClick(videoConfigInfo) {
      this.openVideoSet = true;
      this.$nextTick(() => {
        this.$refs.controldetail.showVideoDialog(videoConfigInfo);
      });
    },
    // left-list点击回调
    handleClickItem(deviceInfo) {
      console.log(deviceInfo);
      if (this.$refs.controldetail.dialogVisible) {
        this.$refs.controldetail.handleClose();
        setTimeout(() => {
          this.handleClickItem(deviceInfo);
        }, 300);
        return;
      }

      if (deviceInfo.buildingCode) {
        this.canvasLoading = true;
        this.getFireDeviceByFloor(deviceInfo);
      } else {
        this.canvasList = [];
        this.clearCanvas();
        this.$message.warning("该设备未配置点位");
      }
      this.drawingSrc = deviceInfo.fileCode || "";
      this.controlDetailInfo = deviceInfo;
      this.vW = 100;
      this.vH = 100;
      this.marginLeft = 0;
      this.showDeviceTip = false;
      this.moveXDistance = 0;
      this.marginTop = 0;
      this.moveYDistance = 0;
      this.$refs.controldetail.showDetailDialog();
    },
    // control-top 搜索查询回调
    handleSearchList(search) {
      this.page.currentPage = 1;
      this.page.pageSize = 30;
      this.cacheFireDeviceList = [];
      this.queryParams.thirdDeviceIdAndNameStr = search.deviceName;
      this.queryParams.parentThirdDeviceId = search.parentThirdDeviceId;
      this.queryParams.subDeviceMark = search.subDeviceMark;
      this.queryParams.positionFlag = search.positionFlag;
      this.queryParams.relationCameraType = search.relationCameraType;
      this.getFireControlList(this.page, this.queryParams);
    },
    playVideo(type = "live") {
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: this.currentPop.deviceName || this.currentPop.cameraName,
        playId: this.currentPop.thirdDeviceId || this.currentPop.thirdCameraId,
      });
    },
    alarmInfoList() {
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = 10;
      this.workingPage.total = 0;
      this.getalarmData();
      this.alarmDialog = true;
    },
    getalarmData() {
      // console.log(this.clickItem);
      let params = {
        thirdDeviceId: this.clickItem.thirdDeviceId,
        pageNum: this.workingPage.pageNum,
        pageSize: this.workingPage.pageSize,
      };
      this.$fetch(api.alarm.getalarmList, params).then((response) => {
        if (response.success) {
          this.alarmlistData = response.returnObj.list;
          this.workingPage.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取告警信息失败");
        }
      });
    },
    handleSearchReset() {
      this.workingPage.alarmType = [];
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = 10;
      this.getWorkingData();
    },
    handleSearchChange(param) {
      this.workingPage.alarmType = [];
      param.statusDesc && this.workingPage.alarmType.push(param.statusDesc.toString());
      this.getWorkingData();
    },
    alarmControl(val, data) {
      let params = {
        subSystem: data.subSystem,
        alarmType: data.alarmType,
        alarmDevId: data.alarmDevId,
        deviceName: data.deviceName,
        alarmInterval: val.num,
        beginTime: val.ignoreTime ? val.ignoreTime[0] : "",
        endTime: val.ignoreTime ? val.ignoreTime[1] : "",
      };
      this.$fetch(api.cms.addAlarmIgnoreConfig, params).then((res) => {
        if (res.success) {
          this.$message.success("告警抑制配置成功");
          this.$refs.alarmContol.closeDialog();
        } else {
          this.$refs.alarmContol.sbmitLoading = false;
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取消防控制列表
    getFireControlList(page, params) {
      const _this = this;
      this.closeDetail();
      this.$refs.controlList.visibleRightId = "";
      this.$refs.controlList.dataLoading = true;
      this.$fetch(
        api.control.queryFireDeviceList,
        Object.assign(
          {
            pageNum: page.currentPage,
            pageSize: page.pageSize,
          },
          params
        )
      ).then((response) => {
        this.$refs.controlList.dataLoading = false;
        if (response && response.success) {
          _this.fireDeviceList = response.returnObj ? response.returnObj.list : [];
          _this.page.total = response.returnObj ? response.returnObj.total : 0;

          _this.cacheFireDeviceList = _this.cacheFireDeviceList.concat(
            _this.fireDeviceList
          );
          // 配置页面 不刷新
          if (this.controlPageType) {
            return;
          }
          // 获取查询到的设备点位
          _this.canvasList = [];
          _this.clearCanvas();
          // 默认显示第一个数据的设备位置
          _this.cacheFireDeviceList.length &&
            _this.$refs.controlList.itemClick(_this.cacheFireDeviceList[0]);
          // _this.handleClickItem();
          // _this.cacheFireDeviceList.forEach((item) => {
          //   if (item.width && item.height && item.abscissa && item.ordinate) {
          //     let wb = this.cW / item.width;
          //     let hb = this.cH / item.height;
          //     _this.canvasList.push({
          //       width: item.width, //原始大小
          //       height: item.height, //原始大小
          //       x: item.abscissa,
          //       y: item.ordinate,
          //       ...item,
          //     });
          //     let ctx = this.initCanvas();
          //     let img = this.$refs.imgRed;
          //     ctx.drawImage(
          //       img,
          //       item.abscissa * wb - 20,
          //       item.ordinate * hb - 20,
          //       40,
          //       40
          //     );
          //   }
          // });
        } else {
          this.$message.error(response.msgContent || "获取设备数据失败");
        }
      });
    },
    // 滚动加载告警列表数据
    loadMoreControl() {
      this.page.currentPage = this.page.currentPage + 1;
      this.getFireControlList(this.page, this.queryParams);
    },
    // 获取该图纸下所有设备并打点
    getFireDeviceByFloor(deviceInfo) {
      let ctx = this.initCanvas("mycanvas");
      this.clearCanvas("mycanvas");
      this.canvasList = [];
      this.deviceTypes.forEach((el) => {
        el.isActive = true;
        el.list = [];
      });
      let img = this.$refs.img;
      [deviceInfo].forEach((item, index) => {
        img = this.$refs.img;
        // 设备打点--静态图层
        let wb = this.cW / item.width;
        let hb = this.cH / item.height;
        if (item.deviceMark == 32) {
          // 电器火灾
          img = this.$refs.dqhzImg;
          this.deviceTypes[2].list.push({
            width: item.width, //原始大小
            height: item.height, //原始大小
            x: item.abscissa,
            y: item.ordinate,
            ...item,
          });
        } else if (item.deviceMark == 18) {
          //摄像机
          img = this.$refs.cameraImg;
          this.deviceTypes[0].list.push({
            width: item.width, //原始大小
            height: item.height, //原始大小
            x: item.abscissa,
            y: item.ordinate,
            ...item,
          });
        } else if (
          item.deviceMark == "27" ||
          item.deviceMark == "28" ||
          item.deviceMark == "29"
        ) {
          // 消防设备
          this.deviceTypes[1].list.push({
            width: item.width, //原始大小
            height: item.height, //原始大小
            x: item.abscissa,
            y: item.ordinate,
            ...item,
          });
        }
        if (item.deviceId == this.controlDetailInfo.deviceId) {
          // 选择设备
          img = this.$refs.imgCheck;
        }

        // 默认显示第一个点
        ctx.drawImage(img, item.abscissa * wb - 12.5, item.ordinate * hb - 12.5, 25, 25);
      });
      this.deviceTypes.forEach((el) => {
        this.canvasList = this.canvasList.concat(el.list);
      });
      this.canvasLoading = false;
    },
    //查询设备详情--弹窗详情使用（如果是告警 则调告警详情）
    getDeviceDetails(id) {
      let params = {
        deviceId: id,
      };
      this.currentPop = {};
      // 设备详情
      this.$fetch(api.device.getDeviceDetails, params).then((response) => {
        if (response.success) {
          this.currentPop = response.returnObj.deviceInfo;
          this.showDeviceTip = true;
          this.matchTip();
          if (
            this.openVideoSet == true &&
            this.currentPop.deviceType == 18 &&
            this.$refs.controldetail.videoConfigInfo.relationCameraType == 3
          ) {
            // 开启位置配置中,不存在则添加
            if (
              !this.$refs.controldetail.tableData.some((el) => {
                return el.deviceId == this.currentPop.deviceId;
              })
            ) {
              this.$refs.controldetail.tableData.push({
                cameraName: this.currentPop.deviceName,
                deviceId: this.currentPop.deviceId,
                relationCameraType: this.currentPop.relationCameraType,
                thirdCameraId: this.currentPop.thirdDeviceId,
              });
              this.$refs.controldetail.cameraIdList.push(this.currentPop.thirdDeviceId);
            }
          }
        } else {
          this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
    },
    // 计算弹窗位置
    matchTip() {
      if (this.canvasList.length && this.showDeviceTip) {
        this.canvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          // 显示该设备tip
          if (el.deviceId == this.currentPop.deviceId) {
            this.tipStyle.left = Math.round(el.abscissa * wb + this.getMarinLeft - 175);
            this.tipStyle.top = Math.round(el.ordinate * hb + this.getMarginTop + 25);
          }
        });
      }
    },
    equipmentOperation() {
      let newMsg = window.location.href.split("#")[0];
      window.open(newMsg + "#/fireManage?id=" + this.currentPop.deviceId);
    },
    showOperationData() {
      this.linkDialog = true;
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = 10;
      this.getWorkingData();
    },
    // 获取运行数据列表
    getWorkingData() {
      let params = {
        deviceId: this.currentPop.deviceId,
        alarmTypeList: this.workingPage.alarmType,
        pageNum: this.workingPage.pageNum,
        pageSize: this.workingPage.pageSize,
      };
      this.$fetch(api.alarm.getWorkingList, params).then((response) => {
        if (response.success) {
          this.workingData = response.returnObj.list;
          this.workingPage.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取运行数据失败");
        }
      });
    },
    personChangeSize(val) {
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = val;
      if (this.alarmDialog) {
        this.getalarmData();
        return;
      }
      this.getWorkingData();
    },
    currentChange(val) {
      if (this.alarmDialog) {
        this.getalarmData();
        return;
      }
      this.workingPage.pageNum = val;
      this.getWorkingData();
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 获取canvas father W H
    getCanvasWH() {
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.redrawImg(6.5);
      this.matchTip();
    },
    // 画布点击 && 回调
    clickPoints() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      canvas.addEventListener("click", function (e) {
        that.showPopover(e);
      });
    },
    showPopover(e) {
      // 点击相对坐标
      let x = e.offsetX;
      let y = e.offsetY;
      //静态点击选中数据
      let clickData = this.canvasList.filter((el, index) => {
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        return (
          Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) < this.imgW * this.imgH
        );
      });
      if (clickData && clickData.length) {
        this.clickItem = clickData[0];
        let clickId = this.clickItem.deviceId || this.clickItem.parentDeviceId;
        this.getDeviceDetails(clickId);
      } else {
        // 点击空白处关闭气泡并重绘canvas 取消点位高亮效果
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.fire-control-page {
  width: 100%;
  height: 100%;
  // padding: 0 10px;
  .fire-control-main {
    position: absolute;
    z-index: 3;
    width: 350px;
    height: 100%;
    background-color: rgba(11, 18, 35, 0.35);
    backdrop-filter: blur(5px);
    .ioc-alarm__list {
      top: 0px;
      left: 0px;
      height: calc(100% - 0px) !important;
      .ioc-alarm__list__item {
        li {
          height: 100px;
        }
      }
    }
  }
  .fire-control-top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    z-index: 3;
    position: absolute;
    left: 368px;
    top: 0px;
    background: rgba(11, 18, 35, 0.35);
    // @include set_theme_color(background-color, page-tab-item-bg-color);

    .ioc-alarm__type > span {
      margin: 7px;
    }
    .ioc-alarm__type {
      margin: 0 25px;
    }
    .control__pageImg {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      padding: 5px 10px;
    }
  }
  .section-mian_right {
    position: relative;
    z-index: 2;
    // margin-bottom: 10px;
    .louceng-img {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .canvasMain {
      position: relative;
      background: rgba(128, 128, 128, 0.5);
      width: 100%;
      height: 100%;
      overflow: hidden;
      .canvasMainT {
        position: absolute;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        canvas {
          position: absolute;
        }
      }
    }
    .marTip {
      .restCanvas {
        &:hover {
          opacity: 0.8;
        }
      }
      div {
        position: absolute;
        right: 25px;
        bottom: 15px;
        color: #121722;
      }
    }
    .no-drawing {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: black;
      font-size: 24px;
      display: flex;
      /*实现垂直居中*/
      align-items: center;
      /*实现水平居中*/
      justify-content: center;
      text-align: justify;
    }
  }
}
.canvasTip {
  z-index: 2;
  position: absolute;
}
</style>
